export const SOCIAL_MEDIA = {
  LINE: 'https://line.me/R/ti/p/@347luzyv',
  FACEBOOK: 'https://www.facebook.com/AimsClinicByDoctorAmy',
  TIKTOK: 'https://www.tiktok.com/@dr.amy.aimsclinic',
  INSTAGRAM: 'https://www.instagram.com/aims.clinic/',
  PHONE: 'tel:0829517770',
}
